import { DropdownOption, DropdownSelectOption } from '@keplerco/core';
import { SortByOption, SortByOptionDescription } from '../../enums/sort-by-option';
import { FilteringSearchParams } from '../../models/overmind/search-params';
import { AssessmentSubType, AssessmentSubTypeDescription, AssessmentType, AssessmentTypeDescription } from '../../enums/assessment-type';
import { CompletionStatus } from '../../enums';
import { CompletionStatusDescription } from '../../enums/completion-status';

export const SORT_BY_OPTIONS: DropdownOption[] = [
  { value: SortByOption.AlphabeticalAtoZ, label: SortByOptionDescription.AlphabeticalAtoZ },
  { value: SortByOption.AlphabeticalZtoA, label: SortByOptionDescription.AlphabeticalZtoA },
  { value: SortByOption.MostRecentlyCreated, label: SortByOptionDescription.MostRecentlyCreated },
  { value: SortByOption.ScoreHighToLow, label: SortByOptionDescription.ScoreHighToLow },
  { value: SortByOption.ScoreLowToHigh, label: SortByOptionDescription.ScoreLowToHigh },
  { value: SortByOption.RecentlyCompleted, label: SortByOptionDescription.RecentlyCompleted },
  { value: SortByOption.RecentlyUpdated, label: SortByOptionDescription.RecentlyUpdated },
];

export const assessmentSortByOptions: DropdownSelectOption[] = [
  { label: SortByOptionDescription.AlphabeticalAtoZ, value: SortByOption.AlphabeticalAtoZ },
  { label: SortByOptionDescription.AlphabeticalZtoA, value: SortByOption.AlphabeticalZtoA },
  { label: SortByOptionDescription.MostRecentlyCreated, value: SortByOption.MostRecentlyCreated },
  { label: SortByOptionDescription.RecentlyActivated, value: SortByOption.RecentlyActivated },
];

export const DEFAULT_FILTERING_SEARCH_PARAMS: FilteringSearchParams = {
  departmentSlugs: undefined,
  teamSlugs: undefined,
  roleSlugs: undefined,
  skillSlugs: undefined,
  countryIds: undefined,
};

export const MAX_PAGE_SIZE = 99999;

export const ASSESSMENT_SUB_TYPE_OPTIONS: DropdownSelectOption[] = [
  { value: AssessmentSubType.GroupAssessment.toString(), label: AssessmentSubTypeDescription.GroupAssessment },
  { value: AssessmentSubType.RatingAssessment.toString(), label: AssessmentSubTypeDescription.RatingAssessment },
  { value: AssessmentSubType.QuestionnaireAssessment.toString(), label: AssessmentSubTypeDescription.QuestionnaireAssessment },
  { value: AssessmentSubType.FOPAssessment.toString(), label: AssessmentSubTypeDescription.FOPAssessment },
];

export const ASSESSMENT_TYPE_OPTIONS: DropdownSelectOption[] = [
  { value: AssessmentType.PeerEndorsement.toString(), label: AssessmentTypeDescription.PeerEndorsement },
  { value: AssessmentType.Questionnaire.toString(), label: AssessmentTypeDescription.Questionnaire },
  { value: AssessmentType.FieldsOfPractice.toString(), label: AssessmentTypeDescription.FieldsOfPractice },
];

export const COMPLETION_STATUS_OPTIONS: DropdownSelectOption[] = [
  { value: CompletionStatus.NotStarted.toString(), label: CompletionStatusDescription.NotStarted },
  { value: CompletionStatus.InProgress.toString(), label: CompletionStatusDescription.InProgress },
  { value: CompletionStatus.Completed.toString(), label: CompletionStatusDescription.Completed },
];

